import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../Header';
import styles from './styles.module.scss';

// TODO: Setup module aliases with TS
import theme from '../../theme';
import AnnouncementBar from 'components/AnnouncementBar';

type LayoutProps = {
  children: React.ReactNode;
  className: string;
};

const Layout = ({ children, className }: LayoutProps) => {
  const segmentWriteKey = process.env.REACT_APP_SEGMENT_WRITE_KEY || 'b9TpOxq2Kbhw950633COoKlik7Cr4ufz';
  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <Helmet
          htmlAttributes={{
            lang: 'en',
          }}
        >
          <title>Tempo | Registration </title>
          <meta
            name="description"
            content={
              'Powered by 3D sensors and A.I., Tempo delivers the personalized guidance of a 1-on-1 trainer, while bringing the heat of your favorite group fitness class.'
            }
          />

          <script src={
            process.env.REACT_APP_TEMPO_API_URL?.includes("api.trainwithpivot.com") ?
              "https://assets.tempo.fit/scripts/tempo_events.js":
              "https://assets.tempo.fit/scripts/tempo_events_staging.js"
            } type="text/javascript"></script>

          <script>
            {`!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${segmentWriteKey}";;analytics.SNIPPET_VERSION="4.15.3";
  analytics.load("${segmentWriteKey}");
  analytics.page();
  }}();`}
          </script>

          <script type="application/ld+json">
            {`{
                    "@context": "https://schema.org/", 
                    "@type": "Product", 
                    "name": "Tempo Studio",
                    "image": 'http://tempo.fit.s3-website-us-west-1.amazonaws.com/img/tempo-facebook-og.png',
                    "description": "Less binge watching, more fat burning. The Tempo comes complete with everything you need to transform your workout at home—including premium equipment powered by the best of the fitness world’s coaches and classes.",
                    "brand": "Tempo",
                    "offers": {
                      "@type": "Offer",
                      "priceCurrency": "USD",
                      }
                    }`}
          </script>
        </Helmet>
      </HelmetProvider>
      <main className={`${styles.main} ${className}`}>
        {process.env.REACT_APP_ANNOUNCEMENT_ENABLED === 'true' && (
          <AnnouncementBar bg="#000" color="#fff">
            {process.env.REACT_APP_ANNOUNCEMENT_MESSAGE}
          </AnnouncementBar>
        )}
        <Header />
        <div className={styles.contentWrapper}>{children}</div>
      </main>
    </ThemeProvider>
  );
};

export default Layout;
